import type { ComponentProps } from 'react';
import React from 'react';

import Carousel from 'common/components/Carousel';
import ContentCard from 'common/components/ContentCard';

interface ContentCarouselProps {
  title: string;
  subtitle: string;
  withCardFrame?: boolean;
  items: Array<Omit<ComponentProps<typeof ContentCard>, 'index' | 'withCardFrame'>>;
}

const getDimensionsConfig = () => ({
  slideGap: [16, 24, 24, 32],
  cardWidth: [212, 242, 294, 424],
});

const ContentCarousel = ({ title, subtitle, withCardFrame, items }: ContentCarouselProps) => {
  const { slideGap, cardWidth } = getDimensionsConfig();

  return (
    <div data-corgi-id="content-carousel">
      <Carousel title={title} subtitle={subtitle} slideGap={slideGap} withTopControls>
        {items.map((item, index) => (
          <section key={index} data-testid="content-carousel-slide">
            <ContentCard
              index={index}
              cardWidth={cardWidth}
              {...item}
              withCardFrame={withCardFrame}
            />
          </section>
        ))}
      </Carousel>
    </div>
  );
};

export default ContentCarousel;
